import axios from 'axios';

const getList = async function logsServiceGetList (params = {}) {
  const response = await axios.get('/api/log/', { params });

  return response.data.data;
};

const getById = async function logsServiceGetById (id) {
  const response = await axios.get(`/api/log/${id}`);

  return response.data.data;
};

const create = async function logsServiceCreate (data) {
  const response = await axios.post('/api/log/', data);

  return response.data.data;
};

const update = async function logsServiceUpdate (id, data) {
  const response = await axios.put(`/api/log/${id}`, data);

  return response.data.data;
};

const remove = async function logsServiceRemove (id) {
  const response = await axios.delete(`/api/log/${id}`);

  return response.data.data;
};

const workerOptions = async function logsServiceWorkerOptions () {
  const response = await axios.get('/api/worker');

  return response.data.data.map(worker => ({
    value: worker.id,
    text: worker.name,
  }));
};

const projectOptions = async function logsServiceProjectOptions () {
  const response = await axios.get('/api/project');

  return response.data.data.map(project => ({
    value: project.id,
    text: project.name,
  }));
};

export default {
  getList,
  getById,
  create,
  update,
  remove,

  workerOptions,
  projectOptions,
};
